module.exports = __webpack_public_path__ + "img/main_partner_inquiry.08609968.png";